import React from 'react';
import { Container, Typography, Box, Divider, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom'; // ✅ Import Link from React Router

export default function PrivacyPolicy() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, sm: 16 } }}>
      <Typography variant="h4" gutterBottom align="left">
        Privacy Policy
      </Typography>
      <Divider sx={{ mb: 4 }} />

      {/* 1. Introduction */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          1. Introduction
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Welcome to FalconXcellence. We respect your privacy and are committed to protecting your
          personal data. This Privacy Policy explains how we collect, use, and safeguard your
          information when you visit our website.
        </Typography>
      </Box>

      {/* 2. Information We Collect */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          2. Information We Collect
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We may collect the following types of information:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1" color="text.secondary">
              Personal details (e.g., name, email address) if provided voluntarily.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" color="text.secondary">
              Technical data such as IP address, browser type, and device information.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" color="text.secondary">
              Usage data, including pages visited and time spent on our site.
            </Typography>
          </li>
        </ul>
      </Box>

      {/* 3. How We Use Your Information */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          3. How We Use Your Information
        </Typography>
        <Typography variant="body1" color="text.secondary">
          The data we collect helps us to:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1" color="text.secondary">
              Improve our website and services.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" color="text.secondary">
              Respond to inquiries and customer support requests.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" color="text.secondary">
              Ensure website security and prevent fraud.
            </Typography>
          </li>
        </ul>
      </Box>

      {/* 4. Cookies and Tracking Technologies */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          4. Cookies and Tracking Technologies
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Our website may use cookies to enhance user experience. You can adjust your browser
          settings to refuse cookies, but some parts of the site may not function properly as a
          result.
        </Typography>
      </Box>

      {/* 5. Third-Party Services */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          5. Third-Party Services
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We may use third-party services for analytics and other functionalities. These third
          parties are subject to their own privacy policies.
        </Typography>
      </Box>

      {/* 6. Data Security */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          6. Data Security
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We take appropriate security measures to protect your personal data, but no method of
          transmission over the internet is 100% secure.
        </Typography>
      </Box>

      {/* 7. Your Rights */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          7. Your Rights
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Depending on your location, you may have rights regarding your personal data, such as:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1" color="text.secondary">
              Accessing the information we store about you.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" color="text.secondary">
              Requesting correction or deletion of your data.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" color="text.secondary">
              Opting out of marketing communications.
            </Typography>
          </li>
        </ul>
      </Box>

      {/* 8. Changes to This Policy */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          8. Changes to This Policy
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We may update this Privacy Policy from time to time. We encourage you to review it
          regularly. Continued use of our services implies acceptance of any changes.
        </Typography>
      </Box>

      {/* 9. Contact Information */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          9. Contact Us
        </Typography>
        <Typography variant="body1" color="text.secondary">
          If you have any questions about this Privacy Policy, please contact us at{' '}
          <Link
            component="a"
            href="mailto:info@falconxcellence.com"
            sx={{ color: 'inherit', textDecoration: 'none' }}
          >
            info@falconxcellence.com
          </Link>
          .
        </Typography>
      </Box>

      {/* 10. Related Policies */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          10. Related Policies
        </Typography>
        <Typography variant="body1" color="text.secondary">
          For more information, please see our{' '}
          <Link
            component={RouterLink}
            to="/terms"
            sx={{ color: 'inherit', textDecoration: 'none' }}
          >
            Terms & Conditions
          </Link>
          .
        </Typography>
      </Box>
    </Container>
  );
}
